import React from "react";
import WorkersComponents from "../../Component/Employess/EmployeComponent";

function Employees() {
  return  <WorkersComponents />
     
}

export default Employees;
